import api from '@/api'

export default {
  /* 提交球探信息 */
  postScoutInfo(data) {
    return api({
      url: '/scoutData/scoutPlayerDataAdd',
      method: 'POST',
      data
    })
  },
  /* 创建球探报告时 返回球探上次填写的所在单位 */
  scoutPlayerDataScoutOrganization() {
    return api({
      url: '/scoutData/scoutPlayerDataScoutOrganization',
      method: "GET",
    })
  },

  /* 获取评价项 */
  getRateList(type) {
    return api({
      url: `/scoutData/scoutPlayerIndicatorsList/${type}`,
      method: "GET",
    })
  },

  /* 提交球探报告 */
  postScoutRateInfo(data) {
    return api({
      url: '/scoutData/scoutPlayerScoreAdd',
      method: 'POST',
      data
    })
  },

  /* 球员信息编辑 第一步编辑和第三步6添加 */
  postScoutEditInfo(data) {
    return api({
      url: '/scoutData/scoutPlayerDateEdit',
      method: 'POST',
      data
    })
  },

  // 获取球探报告列表 教练/领队用
  getScoutListByTeacher(params) {
    return api({
      url: '/scoutData/scoutPlayerDataListCoachOrLeader',
      method: 'GET',
      params
    })
  },

  // 获取球探报告列表 会员协会用
  getScoutListByOrg(params) {
    return api({
      url: '/scoutData/scoutPlayerDataListOrgan',
      method: 'GET',
      params
    })
  },

  // 获取球探报告列表 系统管理员用/技术支持
  getScoutListBySystem(params) {
    return api({
      url: '/scoutData/scoutPlayerDataListSystem',
      method: 'GET',
      params
    })
  },
  // 获取球探报告列表 系统管理员用/技术支持
  getScoutListPlayerSystem(params) {
    return api({
      url: '/scoutData/scoutListPlayerSystem',
      method: 'GET',
      params
    })
  },
  // 获取球探报告列表 系统管理员用/技术支持 一个球员一条数据
  getScoutListOneDataBySystem(params) {
    return api({
      url: '/scoutData/scoutPlayerOneDataListSystem',
      method: 'GET',
      params
    })
  },
  // 导出球队的球员评价表
  scoutPlayerDataUpload(squadUuid) {
    return api({
      url: `/scoutData/scoutPlayerDataUpload/${squadUuid}`,
      method: 'GET'
    })
  },
  scoutExcellentPlayerDataUpload(params) {
    return api({
      url: '/scoutData/scoutExcellentPlayerDataUpload',
      method: 'GET',
      params
    })
  },

  // 获取球探报告列表  青训中心调用
  getScoutListByYouth(params) {
    return api({
      url: '/scoutData/scoutPlayerDataListYouth',
      method: 'GET',
      params
    })
  },

  // 获取球探报告信息
  getScoutDataInfo(uuid) {
    return api({
      url: `/scoutData/scoutPlayerDataInfo/${uuid}`,
      method: 'GET',
    })
  },

  // 获取球探报告分数信息
  getScoutRateInfo(uuid) {
    return api({
      url:`/scoutData/scoutPlayerScoreInfo/${uuid}`,
      method: 'GET'
    })
  },

  // 球探报告分数编辑
  postScoutRateEditInfo(data) {
    return api({
      url: "/scoutData/scoutPlayerScoreEdit",
      method: 'POST',
      data,
    })
  },

  /* 删除球探报告 */
  deleteScout(uuid) {
    return api({
      url: `/scoutData/scoutPlayerDataDeleted/${uuid}`,
      method: 'POST'
    })
  },
  // 获取赛事列表
  getScoutCompetition(uuid) {
    return api({
      url:`/scoutData/scoutPlayerCompetitionList`,
      method: 'GET'
    })
  },
  // 获取赛事列表
  scoutPlayerDataVerify(id_number, id_name) {
    return api({
      url:`/scoutData/scoutPlayerDataVerify/${id_number}/${id_name}`,
      method: 'GET'
    })
  },
}
